import { useBoundStore } from '@Store/useBoundStore';
import { reportError, ObservabilityErrorSeverity } from '@Services/observability/initObservability';

declare global {
  interface Window {
    SigmaDeviceManager: {
      getDeviceSessionId(): Promise<string>;
    };
  }
}

export const initializeSigmaDevice = async () => {
  try {
    const sessionId = await window.SigmaDeviceManager.getDeviceSessionId();
    useBoundStore.getState().onboardingSlice.setDeviceId(sessionId);
  } catch (error) {
    reportError({
      metadata: {
        name: 'Socure getDeviceSessionId error',
        message: 'Error initializing SigmaDevice',
      },
      severity: ObservabilityErrorSeverity.ERROR,
      groupingHash: 'Socure-getDeviceSessionId-error',
    });
    console.error('Error initializing SigmaDevice', error);
  }
};
